const searchParams = window.location.search;

const getParams = () => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  const allParams = {};
  urlParams.forEach((value, key) => {
    allParams[key] = value;
  });
  return allParams;
};

const handleParams = (key, value) => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  if (key) {
    urlParams.delete(key);
    urlParams.append(key, value);
  }
  return "?" + urlParams.toString();
};
const isProd = window.location.origin === "https://staff.seniorlife.ai";

export { getParams, searchParams, handleParams, isProd };
